import { render, staticRenderFns } from "./ModelRecordHistory.vue?vue&type=template&id=6557764e&scoped=true&"
import script from "./ModelRecordHistory.vue?vue&type=script&lang=js&"
export * from "./ModelRecordHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6557764e",
  null
  
)

export default component.exports